import { AxiosInstance, AxiosPromise, AxiosRequestConfig } from 'axios'
import {
  ListResponse,
  UserListResponse,
  UserRequestParams,
  UserStatus,
} from '/@src/models/api'
import { User } from '/@src/models/user'
import gql from 'graphql-tag'
export function getFollowers(
  api: AxiosInstance,
  id: number,
  limit: number,
  cursor?: string
): Promise<UserListResponse> {
  const data: AxiosRequestConfig = {
    params: {
      first: limit,
      cursor: cursor,
    },
  }
  return api.get(`/v1/user/${id}/followers`, data)
}

export function fetchUserList(
  api: AxiosInstance,
  params: UserRequestParams
): Promise<ListResponse<User>> {
  const data: AxiosRequestConfig = {
    params: {
      limit: params.limit,
      page: params.cursor,
      id: params.id,
      keyword: params.keyword,
    },
  }
  return api.get('/v1/admin/user', data)
}

export function fetchUser(api: AxiosInstance, id: number): Promise<User> {
  return api.get(`/v1/admin/user/${id}`)
}

export function updateUser(api: AxiosInstance, user: User): Promise<User> {
  return api.put(`/v1/admin/user/${user.id}`, user)
}

export function verifyUser(
  api: AxiosInstance,
  id: number,
  text: string
): AxiosPromise {
  return api.post(`/v1/admin/user/${id}/verify`, {
    user_id: id,
    verify_name: text,
  })
}

export function updatePassword(
  api: AxiosInstance,
  password: string
): Promise<User> {
  return api.put(`/v1/admin/user/password`, {
    new_password: password,
  })
}

export function updateUserStatus(
  api: AxiosInstance,
  id: number,
  status: UserStatus
): Promise<User> {
  return api.put(`/v1/admin/user/${id}/status`, {
    status: status,
  })
}

export const FindUsersDocument = gql`
  query findUsers(
    $first: Int
    $email: String
    $mobile: Int
    $ids: [Int]
    $status: String
    $offset: Int
  ) {
    users(
      first: $first
      email: $email
      mobile: $mobile
      ids: $ids
      status: $status
      offset: $offset
    ) {
      items {
        id
        nickname
        avatar
        description
        status
        email
        mobile
        Institution
        credit_subscription {
          credit_info {
            amount
            expired_at
            user_id
          }
          expired_at
          plan
          started_at
          user_id
        }
        memberships {
          level
          expired_at
        }
        privileges {
          name
          expired_at
        }
      }
      total_count
    }
  }
`

export const FindUsersV2Document = gql`
  query Users_v2(
    $mobileNumber: BigInt
    $userIds: [Int]
    $pagination: PaginationInput
  ) {
    users_v2(
      mobile_number: $mobileNumber
      user_ids: $userIds
      pagination: $pagination
    ) {
      nodes {
        id
        nickname
        avatar
        description
        status
        email
        mobile
        Institution
        memberships {
          level
          expired_at
        }
      }
      page_info {
        end_cursor
        has_next_page
      }
      total_count
    }
  }
`

export const addPrivilegeToAccountDocument = gql`
  mutation ($input: NewAddPrivilege!) {
    addPrivilegeToAccount(input: $input)
  }
`
